import { Check, Award } from "lucide-react";

const CRITERIA = [
  { key: "pain", label: "Senza dolore" },
  { key: "control", label: "Controllo" },
  { key: "quality", label: "Qualità" },
];

// Inline mastery confirmation for key movements.
// item_id format: `${levelId}-${keyId}-${criterion}` (e.g. mr-l1-glutebridge-pain)
// These ids are intentionally distinct from exercise-completion ids
// (`${dayId}-${idx}`), so they are NOT counted in day/stats completion.
export function MasteryCheck({ levelId, keyId, criteria, completed, onToggle }) {
  if (!criteria) return null;
  return (
    <div
      data-testid={`mastery-check-${keyId}`}
      className="border border-[#00f0ff]/30 bg-[#00f0ff]/[0.04] p-4"
    >
      <p className="flex items-center gap-1.5 font-head text-base uppercase tracking-wide text-[#00f0ff] mb-3">
        <Award size={16} /> Verifica padronanza
      </p>
      <div className="space-y-2.5">
        {CRITERIA.map(({ key, label }) => {
          const id = `${levelId}-${keyId}-${key}`;
          const isChecked = completed.has(id);
          return (
            <button
              key={key}
              data-testid={`mastery-${keyId}-${key}`}
              onClick={() => onToggle(id, !isChecked)}
              className="flex w-full items-start gap-3 text-left active:scale-[0.99] transition-transform"
            >
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center border-2 transition-colors ${
                  isChecked ? "border-[#00f0ff] bg-[#00f0ff]" : "border-zinc-700 bg-transparent"
                }`}
              >
                {isChecked && <Check size={15} strokeWidth={3.5} className="text-black" />}
              </span>
              <span className="min-w-0">
                <span className="font-head text-sm uppercase tracking-wide text-white">{label}</span>
                <span className="block text-xs leading-relaxed text-zinc-400">{criteria[key]}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
